import io from 'socket.io-client';

export const socket = io('https://app.atharo.app', {
    reconnection: false
})

// export const socket = io('http://localhost:8080', {
//     reconnection: false
// })

export const disconnectSocket = () => {
    if(socket) {
        socket.disconnect()
    }
}

export const joinARoom = (name, room) => {
    socket.emit('joinRoom', {name: name, room: room})
}


